<template>
  <v-container fluid>
    <v-row>
      <!-- Sol: Form Tuvali -->
      <v-col cols="8">
        <h3>Form Tasarımı</h3>
        <draggable v-model="formFields" group="fields" class="drop-zone" :clone="cloneField">
          <v-card
            v-for="(field, index) in formFields"
            :key="index"
            class="mb-2 pa-2"
            @click="editField(field)"
          >
            <div><strong>{{ field.label }}</strong> ({{ field.type }})</div>
          </v-card>
        </draggable>
      </v-col>

      <!-- Sağ: Sürüklenebilir Alanlar -->
      <v-col cols="4">
        <h3>Alanlar</h3>
        <draggable :list="availableFields" group="{ name: 'fields', pull: 'clone', put: false }"   :clone="cloneField" clone-on-drag>
          <v-card
            v-for="(field, index) in availableFields"
            :key="index"
            class="mb-2 pa-2"
            outlined
            tile
          >
            {{ field.label }}
          </v-card>
        </draggable>
      </v-col>
    </v-row>

    <!-- Önizleme -->
    <v-divider class="my-4" />
    <h3>Önizleme</h3>
    <FormRenderer :form="{ fields: formFields }" />

    <!-- 🎛️ Alan Düzenleme Modal'ı -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>Alan Düzenle</v-card-title>
        <v-card-text v-if="selectedField">
          <v-text-field v-model="selectedField.label" label="Etiket (Label)"></v-text-field>
          <v-switch v-model="selectedField.required" label="Zorunlu mu?"></v-switch>

          <div v-if="selectedField.type === 'select'">
            <label>Seçenekler</label>
            <v-text-field
              v-for="(option, idx) in selectedField.options"
              :key="idx"
              v-model="selectedField.options[idx]"
              class="my-1"
              label="Seçenek"
              dense
              outlined
            />
            <v-btn small text @click="selectedField.options.push('')">+ Yeni Seçenek</v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="dialog = false">Kapat</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import draggable from "vuedraggable";
import availableFields from "../plugins/fieldTemplates";
import FormRenderer from "./FormRenderer.vue";

export default {
  components: { draggable, FormRenderer },
  data() {
    return {
      availableFields,
      formFields: [],
      selectedField: null,
      dialog: false
    };
  },
  methods: {
    cloneField(field) {
             console.log("cloneField(field) :",field);
      const id = Math.random().toString(36).substr(2, 5);
      const clone = {
        ...JSON.parse(JSON.stringify(field)),
        model: field.model + '_' + id,
        required: false
      };
      if (clone.type === 'select' && !clone.options) {
        clone.options = ['Seçenek 1', 'Seçenek 2'];
      }
      this.formFields.push(clone);
      console.log("Clone:",clone);
      return clone;
    },
    editField(field) {
      this.selectedField = field;
      this.dialog = true;
    }
  }
};
</script>

<style scoped>
.drop-zone {
  min-height: 400px;
  padding: 10px;
  border: 2px dashed #ccc;
  background-color: #fafafa;
}
</style>
